export default {
  dashboard: "/my-onboarding",
};
